<template>
<div>
     <div v-if="!isLogin" style="margin-top:200px">
          <section v-if="isShow(1)" :style="'background:url(' + require('@/assets/bg-top-right.png') +') fixed '">
               <div v-if="!isLoading" class="text-center mb-12">
                    <span :style="'font-weight: bold;font-size:18px; color:'+(settings[0] ? settings[0].color : '#2F839D')">{{ getName('P3S1HeadTitle') }}</span>
                    <h1 class="textSizeT">{{ getName('P3S1Title') }}</h1>
                    <div class="h-decor" :style="'background:' + (settings[0] ? settings[0].color : '#2F839D') "></div>
               </div>
               <div v-else>
                    <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
                    <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader> <br><br>
               </div>

               <div>
                    <v-row>
                         <v-col v-if="!isLoading" cols="12" lg="6" md="6" sm="12">
                              <p class="textSizeST">{{ getName('P3S1SouTitle1') }}</p>
                              <p class="textSizeP">{{ getName('P3S1Prag1') }}</p>
                              <p class="textSizeP">{{ getName('P3S1Prag2') }}</p>
                         </v-col>
                         <v-col v-else cols="12" lg="6" md="6" sm="12">
                              <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
                              <v-skeleton-loader ref="skeleton" type="paragraph"></v-skeleton-loader>
                         </v-col>

                         <v-col cols="12" lg="6" md="6" sm="12">
                              <v-tabs info v-if="!isLoading" v-model="tab" centered style="background:#000">
                                   <v-tab>{{ $t('normal') }}</v-tab>
                                   <v-tab>{{ $t('nip') }}</v-tab>
                              </v-tabs>
                              <v-skeleton-loader v-else ref="skeleton" type="text"></v-skeleton-loader>
                              <v-tabs-items v-model="tab">
                                   <v-tab-item>
                                        <v-card v-if="!isLoading" class="mx-auto px-8 py-0" max-width="600">
                                             <v-card-title class="textSizeP">
                                                  {{ $t('entrerInfo') }}
                                             </v-card-title>
                                             <v-card-text>

                                                  <div class="text--primary">
                                                       <v-form ref="form">
                                                            <v-text-field v-model="form.username" clearable :label="getUsersLabels ? getUsersLabels.labelUser : 'Nom'" required></v-text-field>

                                                            <v-text-field v-model="form.password" clearable :label="getUsersLabels ? getUsersLabels.lablePass : 'Mote de passe'" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" name="password" @click:append="show1 = !show1" :type="show1 ? 'text' : 'password'" required></v-text-field>
                                                            <p v-if="status[2].status == 1" class="textSizeP2">{{ $t('msgResuleToContact')}}
                                                                 <v-btn @click="goToContact" text color="primary">{{ $t('ici')  }}</v-btn>
                                                            </p>
                                                            <p v-if="status[4].status == 1" class="textSizeP2">{{ $t('demandeCartFidaliti')}}
                                                                 <v-btn @click="showDemandCartModal" text color="primary">{{ $t('ici')  }}</v-btn>
                                                            </p>
                                                       </v-form>
                                                  </div>
                                             </v-card-text>
                                             <v-card-actions>
                                                  <v-btn v-if="!isLoad" :color=" (settings[0] ? settings[0].color : '#2F839D')" dark @click="getResult">
                                                       {{ $t('getResult') }}
                                                  </v-btn>
                                                  <span class="pa-2" v-else>{{ $t('patienter') }}</span>
                                             </v-card-actions>
                                        </v-card>
                                        <v-skeleton-loader v-else ref="skeleton" type="card-avatar, article, actions"></v-skeleton-loader>
                                   </v-tab-item>

                                   <v-tab-item>
                                        <v-card v-if="!isLoading" class="mx-auto px-8 py-0" max-width="600">
                                             <v-card-title class="textSizeP">
                                                  {{ $t('entrerNipInfo') }}
                                             </v-card-title>
                                             <v-card-text>

                                                  <div class="text--primary">
                                                       <v-form ref="form">
                                                            <v-text-field v-model="formNip.nip" clearable :label="$t('nip')" required></v-text-field>

                                                            <v-text-field v-model="formNip.password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" name="password" @click:append="show1 = !show1" :type="show1 ? 'text' : 'password'" clearable :label="$t('password')" required></v-text-field>
                                                            <p v-if="status[2].status == 1" class="textSizeP2">{{ $t('msgResuleToContact')}}
                                                                 <v-btn @click="goToContact" text color="primary">{{ $t('ici')  }}</v-btn>
                                                            </p>
                                                            <p v-if="status[4].status == 1" class="textSizeP2">{{ $t('demandeCartFidaliti')}}
                                                                 <v-btn @click="showDemandCartModal" text color="primary">{{ $t('ici')  }}</v-btn>
                                                            </p>
                                                       </v-form>
                                                  </div>
                                             </v-card-text>
                                             <v-card-actions>
                                                  <v-btn v-if="!isLoad" :color=" (settings[0] ? settings[0].color : '#2F839D')" dark @click="getNipResult">
                                                       {{ $t('getResults') }}
                                                  </v-btn>
                                                  <span class="pa-2" v-else>{{ $t('patienter') }}</span>
                                             </v-card-actions>
                                        </v-card>
                                        <v-skeleton-loader v-else ref="skeleton" type="card-avatar, article, actions"></v-skeleton-loader>
                                   </v-tab-item>
                              </v-tabs-items>
                         </v-col>

                    </v-row>
               </div>
          </section>

     </div>

     <div v-else style="margin-top:200px">
          <div v-if="!isLoading" class="text-center mb-12">
               <span :style="'font-weight: bold;font-size:18px; color:'+(settings[0] ? settings[0].color : '#2F839D')">{{ getName('P3S1HeadTitle') }}</span>
               <h1 class="textSizeT">{{ getName('P3S1Title') }}</h1>
               <div class="h-decor" :style="'background:' + (settings[0] ? settings[0].color : '#2F839D') "></div>
          </div>
          <div v-else>
               <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader>
               <v-skeleton-loader ref="skeleton" type="text"></v-skeleton-loader> <br><br>
          </div>
          <v-row>
               <v-col cols="12" class="py-0" :style="'background:'+(settings[0] ? settings[0].color : '#2F839D')">
                    <v-row>
                         <v-col cols="4" class="py-0">
                              <v-list-item-avatar>
                                   <img :src="require('@/assets/avatars/patient.png')" alt="profil">
                              </v-list-item-avatar>
                              <span class="fullname   hidden-sm-and-down">{{ getFullname   }}</span>
                         </v-col>
                         <v-col cols="4" class="">
                              <span class="fullname   hidden-sm-and-down" :style="localLang == 'fr' ? 'margin-left:130px' : 'margin-right:130px'">{{ $t('listResult')   }}</span>
                         </v-col>
                         <v-col cols="4" class="py-0">
                              <v-btn @click="dialog2 = true" :class="localLang == 'fr' ? 'float-right'+' mt-2 mx-8' : 'float-left'+' mt-2 mx-8' " icon>
                                   <v-icon color="white" size="30">mdi-logout</v-icon>
                              </v-btn>
                              <v-btn @click="refresh" :class="localLang == 'fr' ? 'float-right'+' mt-2 mx-8' : 'float-left'+' mt-2 mx-8' " icon>
                                   <v-icon color="white" size="35">mdi-refresh</v-icon>
                              </v-btn>
                         </v-col>
                    </v-row>
               </v-col>
               <v-col cols="2"></v-col>
               <v-col cols="7">
                    <v-data-table :search="search" v-if="!isLoading" :footer-props="{
                          showFirstLastPage: true,
                          firstIcon: 'mdi-arrow-collapse-left',
                          lastIcon: 'mdi-arrow-collapse-right',
                          prevIcon: 'mdi-minus',
                          nextIcon: 'mdi-plus'
                      }" :headers="headers" class="elevation-1 mt-3 px-5" :items="resultwithNip" :height="inerHeight">

                         <template v-slot:item.file="{ item }">
                              <span @click="showPDF(item)" class="btnShowModal">{{ item.file }}</span>
                         </template>
                    </v-data-table>
                    <v-skeleton-loader v-else ref="skeleton" type="table"></v-skeleton-loader>
               </v-col>
               <v-col cols="2"></v-col>
          </v-row>
     </div>
     <v-dialog style=" background-color: transparent !important;" v-model="dialog15" max-width="650">
          <v-card>
               <v-card-title class="headline ">{{ $t('voResult') }}</v-card-title>
               <v-card-text>
                    <iframe :src=" (settings[0] ? settings[0].n_labo :'' ) + '/result/' + file | URL2" id="ifram1" width="100%" height="550"></iframe>

               </v-card-text>
               <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="dialog15 = false">{{ $t('close') }}</v-btn>
               </v-card-actions>
          </v-card>
     </v-dialog>

     <v-dialog v-model="dialog2" persistent max-width="290">
          <v-card class="borderModal">
               <v-card-title class="headline">{{ $t('logout') }}</v-card-title>
               <v-card-text class="txtLogOut">{{ $t('msgLogout') }}</v-card-text>
               <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="dialog2 = false">{{ $t('non') }}</v-btn>
                    <v-btn color="green darken-1" text @click="logout">{{ $t('oui') }}</v-btn>
               </v-card-actions>
          </v-card>
     </v-dialog>

     <v-dialog v-model="dialog20" persistent max-width="400">
          <v-card class="borderModal">
               <v-card-title class="headline">{{ $t('demandCart') }}
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                         <template v-slot:activator="{ on }">
                              <v-btn v-on="on" color="error" outlined icon @click="dialog20 = false" class="mt-1 mr-2">
                                   <v-icon>mdi-close</v-icon>
                              </v-btn>
                         </template>
                         <span>{{ $t('close') }}</span>
                    </v-tooltip>
               </v-card-title>
               <v-card-text class=" px-10">

                    <v-text-field :label="$t('vNom')" v-model="form2.nom_complet" :color="(settings[0] ? settings[0].color : '#2F839D')" append-icon="mdi-account-outline"></v-text-field>
                    <v-text-field :label="$t('vEmail')" v-model="form2.email" :color="(settings[0] ? settings[0].color : '#2F839D')" append-icon="mdi-email-outline"></v-text-field>
                    <v-text-field type="number" :label="$t('vPhone')" v-model="form2.telephone" :color="(settings[0] ? settings[0].color : '#2F839D')" append-icon="mdi-cellphone-iphone"></v-text-field>
                    <v-textarea rows="3" background-color="#fff" v-model="form2.description" :label="$t('description')" :color="(settings[0] ? settings[0].color : '#2F839D')" dense append-icon="mdi-message-outline"></v-textarea>

               </v-card-text>
               <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark v-if="!isLoad2" @click="sendToEmail" :color="(settings[0] ? settings[0].color : '#2F839D')">{{ $t('send') }}</v-btn>
                    <span class="pa-2" v-else>{{ $t('patienter') }}</span>
               </v-card-actions>
          </v-card>
     </v-dialog>

     <v-dialog v-model="dialog22" persistent max-width="400">
          <v-card>
               <v-card-title class="headline">
                    {{ $t('checkEmailHeader') }}
                    <v-spacer></v-spacer>

                    <v-tooltip bottom>
                         <template v-slot:activator="{ on }">
                              <v-btn v-on="on" color="red" outlined icon @click="close()" class="mt-1 mr-2">
                                   <v-icon>mdi-close</v-icon>
                              </v-btn>
                         </template>
                         <span>{{ $t('close') }}</span>
                    </v-tooltip>
               </v-card-title>
               <v-card-text>
                    <p>{{ $t('textEmailVirify') }}</p>
                    <v-text-field class="mb-4" hide-details v-model="codeFromFeild" dense :label="$t('code')" outlined></v-text-field>
                    <a @click="sendToEmail">{{ $t('resyee') }}</a>
               </v-card-text>
               <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :class="this.localLang == 'fr' ? 'mr-3' : 'ml-3'" v-if="!isLoad" dark :color="(settings[0] ? settings[0].color : '#2F839D')" @click="addDemandCartFidaliti">{{ $t('virify') }}</v-btn>
                    <span :style="'color:'+(settings[0] ? settings[0].color : '#2F839D')" v-else>{{ $t('patienter') }}</span>

               </v-card-actions>
          </v-card>
     </v-dialog>
</div>
</template>

<script>
export default {
     data: () => ({
          compt: 0,
          codeFromEmail: '',
          codeFromFeild: '',
          tab: null,
          isLoad: false,
          isLoad2: false,
          dialog2: false,
          dialog15: false,
          dialog20: false,
          dialog22: false,
          show1: false,
          headers: [{
               text: "Fichier PDF",
               value: "file",
               align: "center",
               sortable: false
          }, {
               text: "Date",
               value: "date_env",
               align: "center",
               sortable: false
          }, ],
          file: '',
          IdUser: 0,
          form: {},
          form2: {},
          formNip: {
               nip: '',
               password: '',
          }
     }),
     methods: {
          init() {
               this.form = {
                    n_labo: '',
                    username: '',
                    password: '',
               }
               this.form2 = {
                    nom_complet: '',
                    email: '',
                    telephone: '',
                    description: '',
                    domainName: document.location.origin
               }
          },
          sendToEmail() {
               if (this.compt <= 3) {
                    this.compt++
                    this.isLoad2 = true

                    axios.post(USER_BACKEND_URL + "getUsers/virifyEmail", {
                         data: JSON.stringify(this.form2)
                    }).then((res) => {
                         this.codeFromEmail = res.data
                         this.isLoad2 = false
                         this.dialog22 = true
                    }, () => {
                         this.isLoad2 = false
                    })
               } else {
                    this.dialog22 = false
                    this.compt = 0
                    localStorage.getItem('lang') == 'fr' ? toastr.warning("Vérifiez l'e-mail s'il est correct", "Attention") : toastr.warning("تأكد من البريد الإلكتروني إذا كان صحيح", "تحذير")
               }
          },
          addDemandCartFidaliti() {
               if (this.codeFromEmail.success.match(/454E58D460212Y(.*)R44R554/)[1] == this.codeFromFeild + "") {
                    this.isLoad2 = true
                    this.$store.dispatch('addDemandCartFidaliti', {
                         data: JSON.stringify(this.form2)
                    }).then(() => {
                         this.isLoad2 = false
                         this.dialog22 = false
                         this.codeFromEmail = ""
                         this.codeFromFeild = ""
                         this.dialog20 = false
                         this.init()
                    }, () => {
                         this.isLoad2 = false
                    })
               } else {
                    localStorage.getItem('lang') == 'fr' ? toastr.error("Ce code est faux!", "Attention") : toastr.error("هذا الرمز خاطئ!", "تحذير")
               }
          },
          showDemandCartModal() {
               this.dialog20 = true
          },
          close() { 
               this.isLoad2 = false
               this.compt = 0
               this.dialog22 = false
          },
          refresh() {
               this.$store.dispatch('getResultWithNip')
          },
          getResult() {
               this.isLoad = true
               this.form.n_labo = this.settings[0].n_labo
               var commit = ''
               var url = 'getResult/resultAnalyse'

               this.$Register2({
                    data: JSON.stringify(this.form)
               }, url, commit).then((data) => {
                    this.file = data.data.result
                    this.dialog15 = true
                    this.isLoad = false
               }).catch((err) => {
                    this.isLoad = false
               })

          },
          getNipResult() {
               this.$store.dispatch('loginWithNip', this.formNip).then(() => {
                    this.$store.dispatch('getResultWithNip')
               }, () => {

               })
          },
          goToContact() {
               this.$router.push('/vip/contact')
          },
          /********************************** */
          isShow(item) {
               let array = this.$store.state.status.filter(e => e.idPage == 3)
               if (array) {
                    for (let i = 0; i < array.length; i++) {
                         if (array[i].idSection == item) {
                              return false
                         } else {
                              return true
                         }
                    }
               }
               return true
          },
          logout() {
               this.$store.dispatch('logoutWithNip')
               this.dialog2 = false
          },
          /********************************** */
          showPDF(item) {

               this.file = item.file
               this.dialog15 = true
               // var url = 'getUsers/downloadPdf'
               // var commit = 'getUsers'

               // this.$Register({
               //      data: JSON.stringify(item)
               // }, url, commit)
          },
     },
     computed: {
          getUsersLabels() {
               return this.$store.state.usersForSite.find(e => e.domainName == document.location.origin)
          },
          isLogin() {
               return this.$store.state.access_token_with_nip
          },
          resultwithNip() {
               return this.$store.state.resultwithNip
          },
          getFullname() {
               return localStorage.getItem('POEJUGUR74SFJOJOG')
          },
          isLoading() {
               return this.$store.state.isLoadings
          },
     },
     created() {
          this.init()
          this.$store.dispatch('getResultWithNip')
     }

}
</script>

<style>
.fullname {
     font-size: 20px;
     color: #fff;
     font-weight: bold;
}

.btnShowModal {
     cursor: pointer;
     margin-left: 5px;
     font-weight: 700;
     background: transparent;
     color: blue;
}
</style>
